import { AxiosResponse } from 'axios';

import { useQueryClient } from '@tanstack/react-query';

import type { TypContractManagementTab, TypeCodeState } from '../../types';
import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeGetContractsParams = {
  startDate?: string;
  endDate?: string;
  selectedDate?: string;
  contractStatus: 'ALL' | TypContractManagementTab;
};

type TypeGetContractsResponse = {
  code: string;
  message: string;
  data: TypeContractItem[];
};

export type TypeContractItem = {
  /** 근로계약 아이디 */
  id: number;
  /** 클러스터 */
  cluster: string;
  /** 물류센터 */
  center: string;
  /** 업무파트 */
  workPart: string;
  /** 팀명 */
  teamName: string;
  /** 근로계약 서명일 (yyyy-MM-dd) */
  signedAt?: string;
  /** 근로계약  취소일 (yyyy-MM-dd) */
  cancelledAt?: string;
  /** 근로계약 상태 */
  contractStatus: TypeCodeState;
  /** 근무시간 shift */
  workTimeShift: string;
  /** 클러스터 코드, 문구 */
  displayCluster: TypeCodeState;
  /** 물류센터 코드, 문구 */
  displayCenter: TypeCodeState;
  /** 업무파트 코드, 문구 */
  displayWorkPart: TypeCodeState;
  /** 근로계약 번호 */
  contractNo: string;
};

/**
 * @description 근로계약 목록 조회 api 요청에 사용되는 커스텀 훅
 */
export const useGetContracts = () => {
  const queryClient = useQueryClient();

  const requestGetContracts = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeGetContractsParams;
    onSuccess: (response: TypeGetContractsResponse) => void;
    onError: (error: TypeErrorFormat) => void;
  }) => {
    const endpoint = '/labor/contracts';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeGetContractsResponse>>({
      queryKey: ['contracts', params],
      queryFn: () => axiosInstance.get<TypeGetContractsResponse>(endpoint, { params }),
      gcTime: 0,
    });

    return requestHelper(() => query, onSuccess, onError);
  };

  return requestGetContracts;
};
